import { Button, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import * as MuiIcons from '@mui/icons-material';

export interface Props {
    text: string;
    callback: () => void;
    testId: string;
}

const AddButton: React.FunctionComponent<Props> = (props) => {

    const { text, callback, testId } = props;
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Button
            id="record-add-button"
            data-testid={testId}
            style={{
                flexDirection: 'row',
                backgroundColor: PXBColors.white[50]
            }}
            variant="outlined"
            color="primary"
            onClick={callback}
        >
            {md ? text : <MuiIcons.Add></MuiIcons.Add>}
        </Button>
    );
};

export default AddButton;
